import { currentUser, HomeboundUser } from "@homebound/auth-components";
import { Avatar, Css, useTestIds } from "@homebound/beam";
import { useEffect, useState } from "react";
import { useCurrentUserQuery } from "src/routes/profile/UserProfile.generated";

export function UserProfile() {
  const [user, setUser] = useState<HomeboundUser | undefined>();
  const [isLoadingUser, setIsLoadingUser] = useState(true);
  const { data, error } = useCurrentUserQuery();
  const tid = useTestIds({}, "userProfile");

  useEffect(() => {
    void currentUser()
      .then(({ data }) => setUser(data))
      .finally(() => setIsLoadingUser(false));
  }, []);

  if (isLoadingUser) {
    return <div {...tid} />;
  }

  return user ? (
    <div css={Css.md.$} {...tid}>
      <div css={Css.my2.$}>
        <div>
          <Avatar src={user.picture} name={user.name} showName size="xl" />
          <div>
            <p>{user.email}</p>
            <p>{user.phone}</p>
          </div>
        </div>
      </div>
      <div>
        <h2>Backend User Profile</h2>
        <div>
          {data && data.currentUser && (
            <div>
              <p>{data.currentUser.name}</p>
              <p>{data.currentUser.email}</p>
            </div>
          )}
          {error && error.message}
        </div>
      </div>
    </div>
  ) : (
    <p {...tid}>No profile found</p>
  );
}
